import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import Title from "../shared/Title";
import { ternary } from "../utils/javascript";
import { loadStateFn } from "../utils/localStorage";
import routes from "./routes";

const finalComponent = (
  isAuth,
  isUserLoggedIn,
  Component,
  pathname,
  props,
  title
) => {
  const FinalRedirectUrl = <Redirect to={{ pathname }} />;
  const FinalComponent = (
    <>
      <Title title={title} />
      {ternary(!Component, FinalRedirectUrl, <Component {...props} />)}
    </>
  );

  if (isAuth) return ternary(loadStateFn(), FinalRedirectUrl, FinalComponent);
  if (isUserLoggedIn)
    return ternary(loadStateFn(), FinalComponent, FinalRedirectUrl);
  return FinalComponent;
};

const Routing = () => (
  <Switch>
    {routes.map(
      (
        { isAuth, isUserLoggedIn, component, title, redirectUrl, ...rest },
        index
      ) => (
        <Route
          {...rest}
          key={index}
          render={(props) =>
            finalComponent(
              isAuth,
              isUserLoggedIn,
              component,
              redirectUrl,
              props,
              title
            )
          }
        />
      )
    )}
  </Switch>
);

export default Routing;
